import type { AgendaItem } from "@repo/types";
import { MeetingRunPresentSection } from "./MeetingRunPresentSection";
import { MeetingRunMotionSection } from "./MeetingRunMotionSection";
import { MeetingRunDiscussionSection } from "./MeetingRunDiscussionSection";
import { MeetingRunMotionsSection } from "./MeetingRunMotionsSection";
import { MeetingRunVotingSection } from "./MeetingRunVotingSection";
import type { MeetingRunSectionProps } from "./meetingRunSectionProps";

export type SectionId = "present" | "move" | "discuss" | "motions" | "voting";

export type Section = {
  id: SectionId;
  title: string;
  isComplete?: (item: AgendaItem) => boolean;
  component: React.ComponentType<MeetingRunSectionProps>;
};

export const sections: Section[] = [
  {
    id: "present",
    title: "Presentation",
    component: MeetingRunPresentSection,
  },
  {
    id: "move",
    title: "Moved/Seconded",
    isComplete: (agendaItem: AgendaItem) => {
      return !!(
        agendaItem.review &&
        agendaItem.review.moved &&
        agendaItem.review.seconded
      );
    },
    component: MeetingRunMotionSection,
  },
  {
    id: "discuss",
    title: "Discussion",
    component: MeetingRunDiscussionSection,
  },
  {
    id: "motions",
    title: "Motions",
    component: MeetingRunMotionsSection,
  },
  {
    id: "voting",
    title: "Voting",
    isComplete: (agendaItem) => {
      return !!(
        agendaItem.review &&
        agendaItem.review.votes &&
        agendaItem.review.status &&
        agendaItem.review.status !== "pending"
      );
    },
    component: MeetingRunVotingSection,
  },
];

export const getSectionById = (id: SectionId): Section => {
  const section = sections.find((section) => section.id === id);
  if (!section) {
    throw new Error("Section not found");
  }
  return section;
};
